import React from 'react'
import { SettingsIcon } from 'lucide-react'

interface SettingsProps {
  isSelected?: boolean
  size?: number
}

export const TeamSettingsIcon: React.FC<SettingsProps> = ({ isSelected = false, size = 20 }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return <SettingsIcon size={size} className={className} stroke={stroke} />
}

export default TeamSettingsIcon
